var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { attrs: { id: "result-search-page" } },
    [
      _c("div", { class: _vm.containerClasses }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "search-result-top" }, [
            _c("div", { staticClass: "top" }, [
              _c("div", { staticClass: "left" }, [
                _c("h2", [
                  _vm._v(
                    "\n                            " +
                      _vm._s(_vm.title) +
                      "\n                        "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "right" },
                [
                  _vm.vehicleIds.length
                    ? [
                        _vm.canCopyFavouriteList
                          ? _c(
                              "a",
                              {
                                staticClass: "btn",
                                on: {
                                  click: function($event) {
                                    _vm.copyFavListModelOpen = true
                                  }
                                }
                              },
                              [_vm._v("Copy Favourites")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "btn",
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                _vm.emailModelOpen = true
                              }
                            }
                          },
                          [_vm._v("Send Email")]
                        ),
                        _vm._v(" "),
                        _vm.$userIsAdmin()
                          ? _c(
                              "a",
                              {
                                staticClass: "btn",
                                on: {
                                  click: function($event) {
                                    return _vm.sendRecommend()
                                  }
                                }
                              },
                              [_vm._v("Send Recommend")]
                            )
                          : _vm._e()
                      ]
                    : _vm._e()
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bottom" },
              [
                _c("span", { staticClass: "showing" }, [
                  _c("strong", [_vm._v("Showing")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.from))]),
                  _vm._v("-"),
                  _c("span", [_vm._v(_vm._s(_vm.to))]),
                  _vm._v(" of "),
                  _c("span", [_vm._v(_vm._s(_vm.total))]),
                  _vm._v(
                    "\n                        results\n                    "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "view-type-selection" }, [
                  _c(
                    "label",
                    {
                      class: _vm.viewType === "grid" ? "active" : "",
                      attrs: { for: "view-grid" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.viewType,
                            expression: "viewType"
                          }
                        ],
                        attrs: {
                          id: "view-grid",
                          type: "radio",
                          value: "grid"
                        },
                        domProps: { checked: _vm._q(_vm.viewType, "grid") },
                        on: {
                          change: function($event) {
                            _vm.viewType = "grid"
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("icon", { attrs: { icon: " fa-lg fa-th" } })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      class: _vm.viewType === "list" ? "active" : "",
                      attrs: { for: "view-list" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.viewType,
                            expression: "viewType"
                          }
                        ],
                        attrs: {
                          id: "view-list",
                          type: "radio",
                          value: "list"
                        },
                        domProps: { checked: _vm._q(_vm.viewType, "list") },
                        on: {
                          change: function($event) {
                            _vm.viewType = "list"
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("icon", { attrs: { icon: " fa-lg fa-list" } })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.perRow,
                        expression: "perRow"
                      }
                    ],
                    staticClass: "per-row",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.perRow = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  _vm._l(_vm.vehicles_in_row_options, function(option) {
                    return _c("option", { domProps: { value: option.value } }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(option.text) +
                          "\n                        "
                      )
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.$userCan("administrate")
                  ? _c("user-selector", {
                      staticClass: "select-all",
                      on: { change: _vm.onUserChange },
                      model: {
                        value: _vm.userFilter,
                        callback: function($$v) {
                          _vm.userFilter = $$v
                        },
                        expression: "userFilter"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("RecentDatesSelector", {
                  staticClass: "select-all",
                  attrs: { showAll: false },
                  on: { change: _vm.onDateChange },
                  model: {
                    value: _vm.selectedAuctionDate,
                    callback: function($$v) {
                      _vm.selectedAuctionDate = $$v
                    },
                    expression: "selectedAuctionDate"
                  }
                }),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.sortByModel,
                        expression: "sortByModel"
                      }
                    ],
                    staticClass: "select-all ml-0 ml-lg-auto",
                    attrs: { name: "sorting", id: "sorting" },
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.sortByModel = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.onSortChange
                      ]
                    }
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [_vm._v("-")]),
                    _vm._v(" "),
                    _vm._l(_vm.order_options, function(data, value) {
                      return _c("option", { domProps: { value: value } }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(data.text) +
                            "\n                        "
                        )
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "large-space" },
                  [
                    _c(
                      "b-form-radio-group",
                      {
                        on: { change: _vm.onFavFilter },
                        model: {
                          value: _vm.favouriteListForFilter,
                          callback: function($$v) {
                            _vm.favouriteListForFilter = $$v
                          },
                          expression: "favouriteListForFilter"
                        }
                      },
                      [
                        _c("b-form-radio", { attrs: { value: null } }, [
                          _vm._v("All favourites")
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.favouriteLists, function(fav) {
                          return [
                            _c(
                              "b-form-radio",
                              { attrs: { value: fav.value } },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(fav.text) +
                                    "\n                                "
                                )
                              ]
                            )
                          ]
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "container-table" }, [
            _vm.viewType === "list"
              ? _c(
                  "div",
                  { staticClass: "list-table table-responsive" },
                  [
                    _c("b-table", {
                      staticClass: "list-table",
                      attrs: {
                        "sort-by": _vm.sort_by,
                        "sort-desc": _vm.sort_desc,
                        fields: _vm.fields,
                        items: _vm.favourites,
                        "no-local-sorting": true,
                        "show-empty": ""
                      },
                      on: {
                        "update:sortBy": function($event) {
                          _vm.sort_by = $event
                        },
                        "update:sort-by": function($event) {
                          _vm.sort_by = $event
                        },
                        "update:sortDesc": function($event) {
                          _vm.sort_desc = $event
                        },
                        "update:sort-desc": function($event) {
                          _vm.sort_desc = $event
                        },
                        "sort-changed": _vm.onChange
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "empty",
                            fn: function(scope) {
                              return [
                                _vm.loading
                                  ? [
                                      _vm._v(
                                        "\n                                Loading...\n                            "
                                      )
                                    ]
                                  : [
                                      _vm._v(
                                        "\n                                No data is available...\n                            "
                                      )
                                    ]
                              ]
                            }
                          },
                          {
                            key: "cell(vehicle)",
                            fn: function(data) {
                              return [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.getVehicleLink(data.item)
                                    }
                                  },
                                  [
                                    data.item.front_image_url
                                      ? _c("img", {
                                          attrs: {
                                            src: data.item.front_image_url,
                                            alt: "Front",
                                            height: "50"
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(mileage)",
                            fn: function(data) {
                              return [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.numberWithCommas(data.item.mileage)
                                    ) +
                                    "\n                        "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(auction_date)",
                            fn: function(data) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "time",
                                    attrs: {
                                      title: _vm.getJapanDiff(
                                        data.item.auction_date
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm
                                            .getDateTime(data.item.auction_date)
                                            .format("h:mma")
                                        ) +
                                        " JPN /\n                                " +
                                        _vm._s(
                                          _vm
                                            .getNZDateTime(
                                              data.item.auction_date
                                            )
                                            .format("h:mma")
                                        ) +
                                        " NZ\n                            "
                                    )
                                  ]
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(stock_id)",
                            fn: function(data) {
                              return [
                                data.item.sold &&
                                data.item.sold.heiwa_stock_id &&
                                !data.item.stock_id
                                  ? [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            data.item.sold.heiwa_stock_id
                                          ) +
                                          "\n                            "
                                      )
                                    ]
                                  : [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(data.item.stock_id) +
                                          "\n                            "
                                      )
                                    ]
                              ]
                            }
                          },
                          {
                            key: "cell(actions)",
                            fn: function(data) {
                              return [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.getVehicleLink(data.item)
                                    }
                                  },
                                  [_vm._v("View")]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3760011885
                      )
                    })
                  ],
                  1
                )
              : _c(
                  "div",
                  {
                    staticClass: "container-results",
                    attrs: { id: "container-results" }
                  },
                  [
                    _vm.favourites && _vm.favourites.length
                      ? _vm._l(_vm.favourites, function(vehicle) {
                          return _c("Vehicle", {
                            key: vehicle.id,
                            attrs: {
                              vehicle: vehicle,
                              selected:
                                _vm.selectedVehicles.indexOf(vehicle.api_id) !==
                                -1,
                              priceField: "start_price"
                            },
                            on: { tagPopupModal: _vm.tagPopupModal }
                          })
                        })
                      : [
                          _vm.loading
                            ? [
                                _vm._v(
                                  "\n                            Loading...\n                        "
                                )
                              ]
                            : [
                                _vm._v(
                                  "\n                            No favourites found.\n                        "
                                )
                              ]
                        ],
                    _vm._v(" "),
                    _vm._l([1, 2, 3, 4, 5, 6, 7, 8], function(vehicle) {
                      return _c("div", {
                        staticClass: "single-result-search none"
                      })
                    })
                  ],
                  2
                )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "bottom-container-result d-flex justify-content-end flex-wrap"
            },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-content-end" },
                [
                  _vm.total > 0
                    ? _c("b-pagination", {
                        attrs: {
                          "total-rows": _vm.total,
                          "per-page": _vm.per_page
                        },
                        model: {
                          value: _vm.current_page,
                          callback: function($$v) {
                            _vm.current_page = $$v
                          },
                          expression: "current_page"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]),
        _vm._v(" "),
        _vm.vehicleIds.length
          ? _c(
              "a",
              {
                staticClass: "btn",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    _vm.emailModelOpen = true
                  }
                }
              },
              [_vm._v("Send Email")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.$userIsAdmin()
          ? _c(
              "a",
              {
                staticClass: "btn",
                on: {
                  click: function($event) {
                    return _vm.sendRecommend()
                  }
                }
              },
              [_vm._v("Send Recommend")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.vehicleIds.length && _vm.$userIsAdmin()
          ? _c(
              "a",
              {
                staticClass: "btn pull-right",
                on: {
                  click: function($event) {
                    _vm.recommendModelOpen = true
                  }
                }
              },
              [_vm._v("Recommend")]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.vehicleIds.length
        ? _c("vehicle-recommendation-modal", {
            attrs: {
              notifyMessage: _vm.recommendMessageSendEmail,
              selectedVehicles: _vm.vehicleIds,
              recommend: true
            },
            model: {
              value: _vm.recommendModelOpen,
              callback: function($$v) {
                _vm.recommendModelOpen = $$v
              },
              expression: "recommendModelOpen"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("vehicle-recommendation-modal", {
        attrs: {
          notifyMessage: _vm.notifyMessageSendEmail,
          selectedVehicles: _vm.vehicleIds,
          recommend: false
        },
        model: {
          value: _vm.emailModelOpen,
          callback: function($$v) {
            _vm.emailModelOpen = $$v
          },
          expression: "emailModelOpen"
        }
      }),
      _vm._v(" "),
      _c("favourite-tag-modal", {
        attrs: { vehicleId: _vm.selectedVehicleId },
        on: { changed: _vm.onTagChanged },
        model: {
          value: _vm.favListModalOpen,
          callback: function($$v) {
            _vm.favListModalOpen = $$v
          },
          expression: "favListModalOpen"
        }
      }),
      _vm._v(" "),
      _c("CopyFavListModal", {
        attrs: {
          selectedListId: _vm.favouriteListForFilter,
          userFilter: _vm.userFilter,
          selectedAuctionDate: _vm.selectedAuctionDate
        },
        model: {
          value: _vm.copyFavListModelOpen,
          callback: function($$v) {
            _vm.copyFavListModelOpen = $$v
          },
          expression: "copyFavListModelOpen"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e7120ba", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e7120ba","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Favourites/FavouritesPage.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6e7120ba","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Favourites/FavouritesPage.vue
// module chunks = 0